// Context provider for the injected agent API client.

import { type ReactNode } from 'react';
import { AgentsApiContext } from './AgentsApiContext';
import type { AgentsApiClient } from './types';

export function AgentsApiProvider({
  client,
  children,
}: {
  client: AgentsApiClient;
  children: ReactNode;
}) {
  return (
    <AgentsApiContext.Provider value={client}>{children}</AgentsApiContext.Provider>
  );
}
